module.exports = __webpack_public_path__ + "img/icon-数学@2x.cee674fd.png";